<template>
    <div class="mb-4 select-none">
        <span v-html="questions[questionIndex].content"></span>
    </div>
    <div class="flex flex-col gap-2">
        <div v-for="answer in questions[questionIndex].shuffled_answers">
            <div
                @click="selectAnswer(answer)"
                :class="
                    'mb-4 rounded border border-gray-400 p-4 outline outline-4 outline-transparent hover:cursor-pointer hover:border-primary-500 hover:shadow-primary-500 hover:outline-primary-500/25' +
                    ' ' +
                    (answer.isSelected
                        ? 'border-primary-500 bg-primary-500 text-white'
                        : '')
                "
            >
                <div class="">{{ answer.text }}</div>
            </div>
        </div>
    </div>
    <div class="mt-4 flex items-center justify-between">
        <span
            @click="prevQuestion"
            :class="
                'btn btn-lg btn-primary' +
                ' ' +
                (questionIndex > 0 ? '' : 'btn-disabled')
            "
            >Prev Question</span
        >
        <span
            v-if="questionIndex + 1 < questions.length"
            @click="nextQuestion"
            :class="
                'btn btn-lg btn-primary' +
                ' ' +
                (questionAnswered ? '' : 'btn-disabled')
            "
            >Next Question
        </span>
        <span v-else class="btn btn-secondary btn-lg" @click="gradeQuiz"
            >Grade Quiz</span
        >
    </div>
</template>
<script>
export default {
    name: "FrontendPracticeQuizQuestions",
    props: {
        questions: {},
    },
    data() {
        return {
            questionIndex: 0,
        };
    },
    emits: ["grade-quiz", "practice-question-answered"],
    methods: {
        selectAnswer(answer) {
            answer.isSelected = !answer.isSelected;
            this.$forceUpdate();
        },
        prevQuestion() {
            this.questionIndex > 0 ? this.questionIndex-- : null;
        },
        nextQuestion() {
            if (
                this.questionIndex < this.questions.length &&
                this.questionAnswered(this.questions[this.questionIndex])
            ) {
                this.questionIndex = this.questionIndex + 1;
            }

            this.$emit("practice-question-answered");
        },
        questionAnswered(question) {
            return (
                _.find(question.shuffled_answers, function (answer) {
                    return answer.isSelected;
                }) != null
            );
        },
        gradeQuiz() {
            this.$emit("grade-quiz", this.questions);
            this.$emit("practice-question-answered");
        },
    },
};
</script>
